<template>
  <div class="dropdown">
    <label v-if="label !== null" :class="[labelClasses]" style="width: 100%;">
      <i class="m1"
         :class="[tooltipIcon]"
         :title="tooltip"
         v-if="tooltip!==null&&tooltipLeft&&!tooltipRight">
      </i>
      <ks-flex justify="between">
        <ks-block>
          {{ label }}
          <span style="color:red">{{ required ? '*' : '' }}</span>
          <i class="m1" :class="[tooltipIcon]" :title="tooltip" v-if="tooltip!==null&&tooltipRight"></i>
        </ks-block>
        <ks-icon icon="ban" class="btn-link pointer" @onClick="clearCampaigns" title="All Campaigns"/>
      </ks-flex>
    </label>
    <button
        class="btn btn-default dropdown-toggle form-control ks-custom-select-button-dropdown"
        :class="[computedValidationStatus]"
        :id="`button-toggle-${_uid}`"
        @click.prevent="filterOptionsSearch = ''"
        type="button"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
        :disabled="disabled"
    >
      {{ selectedItemLabel ? selectedItemLabel : optionPlaceholder ? optionPlaceholder : '' }}
    </button>
    <div
        class="dropdown-menu select-field-menu"
        aria-labelledby="dropdownMenuButton"
        :style="{'max-height': maxHeight}"
    >
      <!-- Search section -->
      <div style="padding-right: 5px;padding-left: 5px; padding-bottom: 8px; font-size:12px; position: relative;"
           v-if="enableSearch || enableDBSearch">
        <input
            type="text"
            v-model="filterOptionsSearch"
            class="form-control form-control-sm rounded-right"
            placeholder="Search" aria-label="search"
            aria-describedby="search"
            @keydown.enter.prevent=""
            autocomplete="new-password"
        >
        <span class="icon-inside-sm"><i class="fa fa-search"></i></span>
      </div>

      <!-- NEW option -->
      <div class="tree-options" v-if="showNewOption">
        <span @click.prevent="newOptionClicked"
              class="dropdown-item custom-single-select-field-option">
          {{ newOptionLabel }}
        </span>
      </div>

      <!-- NULL option -->
      <div class="tree-options" v-if="showNullOption && filterOptionsSearch.length == 0">
        <span @click.prevent="setCustomOption(null)"
              class="dropdown-item custom-single-select-field-option">
          {{ nullOptionLabel }}
        </span>
      </div>

      <!-- ALL option -->
      <div class="tree-options" v-if="showAllOption && filterOptionsSearch.length == 0">
        <span @click.prevent="setCustomOption(allOptionValue)"
              class="dropdown-item custom-single-select-field-option">
          {{ allOptionLabel }}
        </span>
      </div>

      <!-- Options tree recursive component  -->
      <tree-options
          :key="'label-checkbox-option-' + index + this.enableSearch && !this.enableDBSearch ? filteredOptions.length : input_options.length "
          type="single"
          :nodes="this.enableSearch && !this.enableDBSearch ? filteredOptions : input_options"
          :optionValue="optionValue"
          :optionLabel="optionLabel"
          :nodesName="treeNodesName"
          :model="cValue"
          :depth="0"
          @input="onInput"
          :parentUID="_uid"
      />
    </div>
    <small class="form-text text-muted" v-if="helpText">{{ helpText }}</small>
    <div class="valid-feedback" v-if="computedValidationStatus == 'is-valid'">
      <ul>
        <li v-for="(text, index) in validText" :key="_uid+'success_' + index">{{ text }}</li>
      </ul>
    </div>
    <div class="invalid-feedback" v-if="computedValidationStatus == 'is-invalid'">
      <ul>
        <li v-for="(text, index) in invalidText" :key="_uid + 'error_' + index">{{ text }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex'
import tree_options from './../treeOptions';
import {selectorMixin} from './../mixins/index.js';

export default {
  name: "custom-single-select-field",
  mixins: [selectorMixin],
  props: {
    value: {},
    optionPlaceholder: {
      type: String,
      default: ''
    },
    optionNodes: {
      type: String,
      default: null
    },
    enableSearch: {
      type: Boolean,
      default: false
    },
    enableDBSearch: {
      type: Boolean,
      default: false
    },
    parentId: {
      type: String,
      default: 'parent_id'
    },
    childId: {
      type: String,
      default: 'id'
    },
    maxHeight: {
      type: String,
      default: "650px"
    },
    tooltip: {
      type: String,
      default: null
    },
    tooltipIcon: {
      type: String,
      default: 'fas fa-question-circle'
    },
    tooltipRight: {
      type: Boolean,
      default: false
    },
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    index: {
      type: Number
    },
    inLine: {
      type: Boolean,
      default: false
    },
    inlineLabelColClass: {
      type: String,
      default: 'col'
    },
    classes: {
      type: String,
      required: false
    },
    label: {
      type: String,
      default: null
    },
    options: {
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    optionValue: {
      type: String,
      required: false, //define prop name for take value
      default: 'label'
    },
    optionLabel: { // define prop name for take label
      type: String,
      required: false,
      default: 'label'
    },
    optionFilter: {
      default: null //function to filter
    },
    size: {
      type: String, //sm-lg-md
      default: null
    },

    showAllOption: {
      type: Boolean,
      default: false
    },
    allOptionLabel: {
      type: String,
      default: "None"
    },
    allOptionValue: {
      type: String,
      default: null
    },

    showNewOption: {
      type: Boolean,
      default: false
    },
    newOptionLabel: {
      type: String,
      default: "New"
    },
    showNullOption: {
      type: Boolean,
      default: false
    },
    nullOptionLabel: {
      type: String,
      default: "None"
    },
    enableTree: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    input_options(newVal) {
      this.filteredOptions = JSON.parse(JSON.stringify(newVal));
    },
    value: function (newVal) {
      this.cValue = newVal;
    },
    cValue: function (newVal) {
      this.setSelected(newVal);
      this.$emit('input', newVal);
      this.$emit('onChange', newVal);
    }
  },
  components: {
    'tree-options': tree_options
  },
  computed: {
    ...Vuex.mapGetters({auth: 'rms_ui/auth/auth'}),
    treeNodesName() {
      return this.optionNodes == null ? 'childs' : this.optionNodes;
    },
    input_options() {
      try {
        if (this.treeNodesName == 'childs' && this.enableTree) {
          return this.getTree();
        } else {
          return this.providerOptions;
        }
      } catch (err) {
        return [];
      }
    }
  },
  mounted() {
    this.filteredOptions = JSON.parse(JSON.stringify(this.input_options));
    if (typeof this.value !== 'undefined') {
      setTimeout(() => {
        this.cValue = this.value;
      }, 500);
    }
    this.$emit('onMounted', this);
  },
  methods: {
    clearCampaigns() {
      app.rmsCampaignSelector.clearOptions();
    },
    setSelected(val) {
      let initSelected = this.input_options.filter(o => o[this.optionValue] == val);
      if (initSelected.length > 0) {
        this.selectedItemLabel = initSelected[0][this.optionLabel];
      } else {
        if (val === this.allOptionValue) {
          this.selectedItemLabel = this.allOptionLabel;
        } else {
          this.selectedItemLabel = null;
        }
      }
    },
    getTree(data = []) {
      try {
        //return array parent-child
        let options = data.length > 0 ? data : JSON.parse(JSON.stringify(this.providerOptions));
        options.forEach((parent) => {
          parent['childs'] = [];
          options.forEach((child) => {
            if (child[this.parentId] == parent[this.childId]) {
              child['hasParent'] = true;
              parent['childs'].push(child);
            }
          });
        });
        return options.filter((opt) => !opt.hasParent);
      } catch (err) {
        console.log('KS-APP: ', err);
        return [];
      }
    },
    onInput(data, label) {
      this.selectedItemLabel = label;
      this.filterOptionsSearch = '';
      this.$emit('input', data);
    },
    newOptionClicked() {
      this.$emit('onNewClick', this);
    },
    setCustomOption(value) {
      try {
        document.getElementById(`mcs_input_option_${this._uid}${this.cValue}`).classList.remove('active');
      } catch (err) {
      }
      this.cValue = value;
    }
  },
  data() {
    return {
      filterOptionsSearch: '',
      filteredOptions: [],
      selectedItemLabel: null,
      cValue: null,
      isCustom: true
    }
  }
}
</script>
<style scoped>

.ks-custom-select-button-dropdown {
  border: 1px solid #ced4da;
  text-align: start;
}

.not-a-link {
  color: black;
}

.not-a-link:hover {
  color: black;
  text-decoration: none;
}

.select-field-menu {
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  transform: unset !important;
  top: auto !important;
  left: auto !important;
}

.select-field-caption {
  border: 1px solid #ced4da;
  display: block;
  width: 100%;
  background-color: #fff;
  text-align: start;
}

.custom-single-select-field-option {
  transform: translate(15px);
  cursor: pointer;
}

li {
  list-style-type: none;
}

</style>
